import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {CalendarsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {useSidePanelSafeAreaRegistration} from '../../../../libs/shared/ui/src/components/safeArea/safeAreaHooks';
import {VisualParticipantModel} from '../../../models/api/visualParticipantModel';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarEventOverrides} from '../../../store/panels/calendars/calendarsPanelState';
import {ResizeSeparator, ResizeSeparatorSidesEnum} from '../../common/resizeSeparator';
import {buildFullCalendarEventId} from '../grid/fullCalendarHelpers';
import {CalendarEventEditorWithNotifyGuestsContainer} from './calendarEventEditorContainer';

/*
 * Props.
 */

interface LargeCalendarsEventEditorProps {
  panelId: CalendarsPanelId;
  calendarEventData: CalendarEventData;
  onRequestClose: () => void;
  onFocusedEventOverridesChange: (overrides: CalendarEventOverrides) => void;
  onVisualParticipantsChange: (
    oldVisualParticipants: ReadonlyArray<VisualParticipantModel>,
    newVisualParticipants: ReadonlyArray<VisualParticipantModel>,
  ) => void;
  onViewGuestAvailabilityClick: ((arg: ReadonlyArray<VisualParticipantModel>) => void) | undefined;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 100%;
`;

const StyledEditorDiv = styled.div`
  grid-column: 2;
  display: grid;
`;

/*
 * Component.
 */

export const LargeCalendarsEventEditor: FC<LargeCalendarsEventEditorProps> = (props) => {
  const {panelId, calendarEventData, onRequestClose, onFocusedEventOverridesChange} = props;
  const {calendarEventVersion, calendarVersion, instanceStartDate} = calendarEventData;
  const [editorSize, setEditorSize] = useState(300);

  const {onResizeEnd} = useSidePanelSafeAreaRegistration(true, editorSize);

  return (
    <StyledWrapperDiv style={{width: editorSize}}>
      <ResizeSeparator
        column={1}
        size={editorSize}
        minSize={270}
        maxSize={800}
        onSizeChange={setEditorSize}
        onResizeEnd={onResizeEnd}
        side={ResizeSeparatorSidesEnum.LEFT}
      />
      <StyledEditorDiv>
        <CalendarEventEditorWithNotifyGuestsContainer
          panelId={panelId}
          key={buildFullCalendarEventId(calendarEventVersion.uid, calendarVersion.id, instanceStartDate)}
          calendarEventData={calendarEventData}
          onRequestClose={onRequestClose}
          onSaveClick={onRequestClose}
          onFocusedEventOverridesChange={onFocusedEventOverridesChange}
          onVisualParticipantsChange={props.onVisualParticipantsChange}
          onViewGuestAvailabilityClick={props.onViewGuestAvailabilityClick}
        />
      </StyledEditorDiv>
    </StyledWrapperDiv>
  );
};
